import { render } from "./Loader.vue?vue&type=template&id=e9637108"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=e9637108&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__